import React from "react";
import "./Specialization.css";
export default function Specialization() {
  
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Krisara Gastro and Liver Clinic",
    url: "https://krisaragastro.com/",
    logo: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    image: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    telephone: "+91 7569541532",
    email: "gastro@krisara.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500014",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/krisaragastro",
      "https://www.instagram.com/krisaragastro",
    ],
  };

  return (
    <div className="specialization-container">
      <h2 className="specialization-title">
        Areas of Specialization
      </h2>
      <div className="specialization-row">
        {/* Advanced Endoscopy Card */}
        <div className="specialization-card">
          <div className="specialization-header">
            <span className="icon" role="img" aria-label="endoscopy">🦠</span>
            <span className="specialization-heading">Advanced Endoscopy</span>
          </div>
          <ul className="specialization-list">
            <li>Upper GI Endoscopy &amp; Therapeutic Interventions</li>
            <li>Colonoscopy &amp; Polypectomy</li>
            <li>ERCP (Endoscopic Retrograde Cholangiopancreatography)</li>
            <li>Endoscopic Ultrasound (EUS) with therapeutic applications</li>
            <li>Balloon and Capsule Enteroscopy</li>
          </ul>
        </div>
        {/* Hepatology Card */}
        <div className="specialization-card">
          <div className="specialization-header">
            <span className="icon" role="img" aria-label="hepatology">🫀</span>
            <span className="specialization-heading">Hepatology (Liver Diseases)</span>
          </div>
          <ul className="specialization-list">
            <li>Fatty Liver Disease<br />(NAFLD/NASH)</li>
            <li>Viral Hepatitis Management</li>
            <li>Liver Cirrhosis Care</li>
            <li>Autoimmune Liver Diseases</li>
            <li>Hepatocellular Carcinoma</li>
          </ul>
        </div>
        {/* Emergency Gastroenterology Card */}
        <div className="specialization-card">
          <div className="specialization-header">
            <span className="icon" role="img" aria-label="emergency">⚡</span>
            <span className="specialization-heading">Emergency Gastroenterology</span>
          </div>
          <ul className="specialization-list">
            <li>Acute GI Bleeding Management</li>
            <li>Emergency Endoscopic Interventions</li>
            <li>Critical Care Gastroenterology</li>
          </ul>
        </div>
      </div>
    </div>
  );
}